import Footer from "./Footer";
import Header from "./Header";

const PaymentPolicy = () => {
  return (
    <>
      <Header />

      <section className="bg-white py-5">
        <div className="container">
          <h1 className="display-6 text-dark">Payment Policy</h1>

          <section>
            <h3 className="text-dark">1. Introduction</h3>
            <p>
              Welcome to <u>Visualaey</u>. This Payment Policy outlines how
              payments are processed, handled, and managed on our platform. By
              using Visualaey’s paid services, you agree to comply with this
              policy.
            </p>
          </section>

          <section>
            <h3 className="text-dark">2. Payment Methods</h3>
            <p>
              Visualaey uses <strong>Razorpay</strong> as our official payment
              gateway. We accept:
            </p>
            <ul>
              <li>
                Credit and Debit Cards (Visa, Mastercard, American Express,
                etc.)
              </li>
              <li>Net Banking</li>
              <li>UPI and Wallet Payments</li>
            </ul>
          </section>

          <section>
            <h3 className="text-dark">3. Secure Transactions</h3>
            <p>
              All payments are securely processed through Razorpay’s encrypted
              payment gateway. Visualaey does not store any sensitive financial
              information on its servers.
            </p>
          </section>

          <section>
            <h3 className="text-dark">4. Payment Confirmation</h3>
            <p>
              Once your payment is successfully processed, a confirmation will
              be sent to your registered email. Access to paid features of
              Visualaey is granted only after successful payment confirmation.
            </p>
          </section>

          <section>
            <h3 className="text-dark">5. Refund and Cancellation Policy</h3>
            <p>
              All payments made on <u>Visualaey</u> are{" "}
              <u>strictly non-refundable</u> and non-cancellable. Once a payment
              is successfully processed, it cannot be reversed or refunded under
              any circumstances, including but not limited to:
            </p>
            <ul>
              <li>Change of mind or personal reasons.</li>
              <li>Partial or unused access to paid features.</li>
              <li>
                Technical issues on the user’s device or internet connection.
              </li>
            </ul>
            <p>
              By making a payment, you acknowledge and accept that Visualaey
              does not provide refunds or allow cancellations.
            </p>
          </section>

          <section>
            <h3 className="text-dark">6. Disputes</h3>
            <p>
              In case of any payment-related disputes, users are advised to
              contact Razorpay support. Visualaey will assist wherever possible
              but is not liable for payment gateway disputes.
            </p>
          </section>

          <section>
            <h3 className="text-dark">7. Changes to Payment Policy</h3>
            <p>
              Visualaey may update this Payment Policy from time to time. Users
              will be notified of significant changes via email or platform
              notifications. Continued use of our paid services constitutes
              acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h3 className="text-dark">8. Contact Us</h3>
            <p>
              For any payment-related queries, please reach out to our support
              team at{" "}
              <a href="mailto:support@visualaey.com">support@visualaey.com</a>.
            </p>
          </section>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PaymentPolicy;
